import {useMutation} from "@apollo/client";
import toast from "react-hot-toast";

import {ChecksModalButton} from "@/components/ChecksModalButton/ChecksModalButton.tsx";
import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {GQL_MAINTENANCE_SCHEDULE_DELETE, GQL_MAINTENANCE_SCHEDULES_LIST} from "@/lib/queries/maintenance.ts";
import {ResponseStatus} from "@/lib/types/common.ts";
import {MaintenanceScheduleListItem} from "@/lib/types/maintenance.ts";

export interface MaintenanceDeleteProps {
  schedule: MaintenanceScheduleListItem;
  show: boolean;
  setShow: (show: boolean) => void;
}

// TODO this needs to be tested once I can create a Maintenance Schedule
export const MaintenanceDelete = ({schedule, show, setShow}: MaintenanceDeleteProps) => {
  const [deleteMaintenance, {reset, loading}] = useMutation(GQL_MAINTENANCE_SCHEDULE_DELETE, {
    refetchQueries: [GQL_MAINTENANCE_SCHEDULES_LIST],
  });

  const handleSubmit = async () => {
    const response = await deleteMaintenance({
      variables: {id: schedule.id},
    });
    if (response.data?.response?.status === ResponseStatus.SUCCESS) {
      setShow(false);
      toast.success("Maintenance schedule deleted successfully.");
    } else {
      toast.error(response.data?.response?.message || "Failed to delete maintenance schedule.");
    }
  };

  return (
    <DeleteActionDialog
      show={show}
      loading={loading}
      title={"Delete Maintenance Schedule"}
      onConfirm={handleSubmit}
      onCancel={() => {
        setShow(false);
        reset();
      }}
    >
      Are you sure you want to permanently delete the maintenance schedule{" "}
      <span className={"pulseTextBodyBold"}>{schedule.name}</span>?
      {schedule.services_count > 0 && (
        <span>
          {" "}
          This will remove this schedule from all linked checks (
          <ChecksModalButton
            id={schedule.id}
            inline
            numberOfChecks={schedule.services_count}
            model_type={"MaintenanceSchedule"}
            title={"Schedule: " + schedule.name}
          >
            {schedule.services_count} checks
          </ChecksModalButton>
          )
        </span>
      )}
    </DeleteActionDialog>
  );
};
